import { useContext } from 'react'

import ConversationActionsCtx from '@/contexts/ConversationActionsContext'

export default function useConversationActions() {
  return useContext(ConversationActionsCtx)
}
